// Kampanya yönetimi: diziyi doldurarak kampanya ekleyin.
// Dizi boşsa ana sayfadaki kampanya bölümü otomatik gizlenir.
// gorselMasaustu: PC (geniş) banner, gorselMobil: mobil banner.
export const CAMPAIGNS = [
  {
    id: "4-taksit",
    baslik: "Tüm Kredi Kartlarına 4 Taksit",
    aciklama: "Peşin fiyatına 4 taksit imkânıyla dilediğiniz aracı hemen kiralayın. Havalimanı teslimatı, şehir içi ve uzun dönem kiralama seçenekleriyle.",
    gorselMasaustu: "/images/campaigns/banner-pc-4-taksit.webp",
    gorselMobil: "/images/campaigns/banner-mobil-4-taksit.webp",
  },
  {
    id: "havalimani-teslimat",
    baslik: "Uçaktan İn, Aracın Hazır",
    aciklama: "İstanbul Havalimanı'nda kolay araç teslimatı. Hızlı teslimat, kolay rezervasyon ve 7/24 destek ile yolculuğunuza beklemeden başlayın.",
    gorselMasaustu: "/images/campaigns/banner-pc-havalimani.webp",
    gorselMobil: "/images/campaigns/banner-mobil-havalimani.webp",
  },
  {
    id: "istanbul-senin",
    baslik: "İstanbul Senin, Yol VoyaCar'la Senin",
    aciklama: "Günlük, aylık ve uzun dönem araç kiralama seçenekleriyle İstanbul'u özgürce keşfedin.",
    gorselMasaustu: "/images/campaigns/banner-pc-istanbul.webp",
    gorselMobil: "/images/campaigns/banner-mobil-istanbul.webp",
  },
];

export const CAMPAIGN_TERMS_TITLE = "VoyaCar Rental – Genel Kampanya Koşulları";

export const CAMPAIGN_TERMS = [
  "VoyaCar Rental tarafından sunulan kampanyalar, aksi ayrıca belirtilmedikçe araç müsaitliği, kiralama dönemi ve VoyaCar Rental kiralama koşullarına bağlı olarak uygulanır.",
  "Kampanyalar başka indirim veya kampanyalarla birleştirilemeyebilir. Rezervasyonların kesinleşmesi araç müsaitliği, kiralama şartlarının karşılanması ve VoyaCar Rental tarafından rezervasyonun onaylanmasına bağlıdır.",
  "VoyaCar Rental; kampanyaların kapsamını, süresini ve koşullarını değiştirme, kampanyayı sınırlandırma, uzatma veya sona erdirme hakkını saklı tutar.",
];

export function getActiveCampaigns() {
  const now = new Date();
  return CAMPAIGNS.filter((c) => !c.gecerlilik || new Date(c.gecerlilik + "T23:59:59") >= now);
}
